import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptTranslation from './locales/pt/translation.json';
import enTranslation from './locales/en/translation.json';
import ptTerms from './locales/pt/terms.json';
import enTerms from './locales/en/terms.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: ptTranslation, terms: ptTerms },
      en: { translation: enTranslation, terms: enTerms },
    },
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en'],
    interpolation: { escapeValue: false },
  });

export default i18n;
